import React, { ReactNode, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { User, onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { getUserRoles } from "../utility/authUtils";

type SuperAdminProtectedRouteProps = {
  children: ReactNode;
};

const SuperAdminProtectedRoute: React.FC<SuperAdminProtectedRouteProps> = ({ children }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [user, setUser] = useState<User | null>(null);
  const [roles, setRoles] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        navigate("/sign-in");
        return;
      }

      setUser(currentUser);
      const userRoles = await getUserRoles(currentUser);
      setRoles(userRoles);
      setLoading(false);

      // Only allow super-admin access
      if (!userRoles.includes('super_admin')) {
        navigate("/unauthorized");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  // Additional check in case the token exists but user isn't authenticated
  const storedToken = localStorage.getItem("accessToken");
  if (!storedToken) {
    return <Navigate to="/sign-in" replace />;
  }

  // Final verification that user is super-admin before rendering children
  if (roles.includes('super_admin')) {
    return null; // or <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default SuperAdminProtectedRoute;